export default "__VITE_ASSET__DU1cHYh0__"